import { useMemo } from "react";
import { BASE_API_URL } from "../../Api/constants";
import { Image } from "@chakra-ui/react";
import { useBranding } from "../../Contexts/BrandingContext";

let Retry = 0;

export default function ClientLogo({ containerProps, ...rest }) {
  const { Name } = useBranding();
  const LogoUrl = useMemo(() => {
    let Url = `${BASE_API_URL}brand/logo/${window.location.host}`;
    document.getElementById("favicon")?.setAttribute("href", Url);
    return Url;
  }, []);
  
  return (
    <>
    
      <Image
        src={LogoUrl}
        alt={Name || "Exista Business Solutions LLC"}
        {...containerProps} 
        {...rest}
        onError={(e) => {
          e.target.onerror = null;
          if (Retry < 3) {
            e.target.src = "/Img/Logo.png";
            Retry++;
          }
        }}
      />
    </>
  );
}